export default "__VITE_ASSET__CXW0QUD2__"